(function () {
  if (window.__saltMarinPartsFinder) return;
  window.__saltMarinPartsFinder = true;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form.tagName !== 'FORM') form = form.closest('form');
      if (!form || !form.hasAttribute('data-parts-finder-form')) return;

      event.preventDefault();

      var fd = new FormData(form);
      var brand = '';
      var model = '';
      var year = '';
      var vBrand = fd.get('parts_finder_brand');
      var vModel = fd.get('parts_finder_model');
      var vYear = fd.get('parts_finder_year');
      var brandSel = form.querySelector('[name="parts_finder_brand"]');
      var modelSel = form.querySelector('[name="parts_finder_model"]');
      var yearSel = form.querySelector('[name="parts_finder_year"]');

      function pfQueryKey(selectEl, formFallback) {
        if (selectEl) {
          var dk = selectEl.getAttribute('data-pf-query-key');
          if (dk && String(dk).trim()) return String(dk).trim();
        }
        return formFallback ? String(formFallback).trim() : '';
      }
      if (vBrand) brand = String(vBrand).trim();
      if (vModel) model = String(vModel).trim();
      if (vYear) year = String(vYear).trim();

      if (!brand && !model && !year) {
        var firstSelect = form.querySelector('select');
        if (firstSelect) firstSelect.focus();
        return;
      }

      var submitMode = form.getAttribute('data-pf-submit') || 'search';
      var colUrl = form.getAttribute('data-pf-collection-url');
      if (submitMode === 'collection' && colUrl) {
        var pb = pfQueryKey(brandSel, form.getAttribute('data-pf-param-brand'));
        var pm = pfQueryKey(modelSel, form.getAttribute('data-pf-param-model'));
        var py = pfQueryKey(yearSel, form.getAttribute('data-pf-param-year'));
        var url = new URL(colUrl, window.location.origin);
        var mergeCurrent = form.getAttribute('data-pf-merge-current-url') === 'true';
        if (mergeCurrent) {
          try {
            var here = new URL(window.location.href);
            if (here.pathname === url.pathname) {
              here.searchParams.forEach(function (val, key) {
                if (key.indexOf('parts_finder') === 0) return;
                if (key === 'page') return;
                url.searchParams.set(key, val);
              });
            }
          } catch (e1) {}
        }
        if (brand && pb) url.searchParams.set(pb, brand);
        if (model && pm) url.searchParams.set(pm, model);
        if (year && py) url.searchParams.set(py, year);
        window.location.href = url.toString();
        return;
      }

      var parts = [];
      if (brand) parts.push(brand);
      if (model) parts.push(model);
      if (year) parts.push(year);

      var action = form.getAttribute('action') || '/search';
      var url = new URL(action, window.location.origin);
      url.searchParams.set('q', parts.join(' ').trim());
      window.location.href = url.toString();
    },
    false
  );
})();
